import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const getUrlSearchParams = () => new URLSearchParams(window.location.search);

const useLocationParams = () => {
  const navigate = useNavigate();

  const getParam = useCallback(
    (key: string) => getUrlSearchParams().get(key),
    [],
  );

  const setParam = useCallback(
    (key: string, value: string) => {
      const query = getUrlSearchParams();
      query.set(key, value);
      navigate({
        search: query.toString(),
      }, { replace: true });
    },
    [navigate],
  );

  const deleteParam = useCallback(
    (key: string) => {
      const query = getUrlSearchParams();
      query.delete(key);
      navigate({
        search: query.toString(),
      }, { replace: true });
    },
    [navigate],
  );

  return { getParam, setParam, deleteParam };
};

export default useLocationParams;
